<template>
        <div class="row ml-auto my-2 my-md-0">
            <div class="d-inline "
                 @click="enLangChange"> 
                 <a class="nav-link" href="#en"><span class="flag-icon flag-icon-us"> </span>  </a>
            </div>
            <div class="d-inline "
                 @click="ruLangChange"> 
                <a class="nav-link" href="#ru"><span class="flag-icon flag-icon-ru"> </span>  </a>
            </div>
            <div class="d-inline "
                @click="geLangChange"> 
                <a class="nav-link" href="#ge"><span class="flag-icon flag-icon-ge"> </span>  </a>
            </div>
            
            <p>{{lang}}</p>
        </div>
</template>

<script>

export default {
 
    data: function ()       
    {
        return{
          lang: 'en'
        };
    },
    methods:{
        //  laguage change functions
        geLangChange(){
            this.lang='ge'
            },
        enLangChange(){
            this.lang='en'
            },
        ruLangChange(){
            this.lang='ru'
            }
    }

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/EN-vers/Header/headerLangs.vue